export default __webpack_public_path__ + "static/media/Cattura13.4031ccb3.jpg";